var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-delete",on:{"click":function($event){return _vm.$emit('delete')}}},[_c('img',{attrs:{"src":require("assets/btn-delete.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }